import {AnimatePresence, motion} from 'motion/react'
import {MetaCard} from 'quickstart/components/tizra/MetaCard'
import {logger, meta} from 'tizra'
import type {BrowseGalleryProps} from '..'
import * as S from '../styles'
import {getMotionProps} from './motion-props'
import {useInfiniteBrowse} from './useInfiniteBrowse'

const log = logger('BrowseGallery/cards')

const MotionCard = motion.create(MetaCard)

export const CardsGallery = ({maxItems, search, slots}: BrowseGalleryProps) => {
  const {bottomRef, items, spinner, spinnerWrapperStyle} = useInfiniteBrowse({
    maxItems,
    search,
  })

  const motionProps = getMotionProps({raiseOnHover: true})

  return (
    <div style={spinnerWrapperStyle}>
      <S.BrowseGalleryGrid>
        <AnimatePresence mode="popLayout">
          {items?.map(r => (
            <MotionCard
              key={meta.key(r)}
              metaObj={r}
              slots={slots}
              stretch
              {...motionProps}
            />
          ))}
        </AnimatePresence>
      </S.BrowseGalleryGrid>
      <div ref={bottomRef} />
      {spinner}
    </div>
  )
}
